module.exports = __webpack_public_path__ + "176788eb154423e192d0ee70644246bd.png";